import clsx from 'clsx';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';

import { StepButton } from '@mui/material';
import { HeaderNavigation, StyledStep, StyledStepperWrapper } from './styles'

import { StepTypeIcon } from 'assets/constants';

import { stepsPassedSet } from 'store/steps';
import { connect } from 'react-redux';
import { useNavigationHeaderArrows } from './hooks';
import { isOverflown, stepHasMissingData } from 'utils';
import { useOnlineBookingLocale } from 'shell/OnlineBookingLocale';
import { updateObjectAfterFirstFalse } from './utils';

const NavigationHeader = (({ steps, currentStepBlocked, stepTypeInputStatus,  onNavigateClick, activeStep, stepsPassed, stepsPassedSet  }) => {
  const { t } = useOnlineBookingLocale();
  const elementRef = useRef(null);
  const [stepperOverflown, setStepperOverflown] = useState(false);
  const { renderArrowButtonLeft, renderArrowButtonRight, scrollDirection } = useNavigationHeaderArrows();
  const mapedStepTypeInputStatus = updateObjectAfterFirstFalse(stepTypeInputStatus)

  useLayoutEffect(()=> {
    setStepperOverflown(isOverflown(".Stepper"));
    function runOnResize() { setStepperOverflown(isOverflown(".Stepper")) };

    window.addEventListener("resize", runOnResize);
    return(() => window.removeEventListener("resize", runOnResize))
  },[])

  useEffect(()=> {
    stepsPassed < activeStep  && stepsPassedSet(activeStep)
  }, [activeStep]);

  useEffect(() => {
    const container = elementRef?.current;
    const widthToJump = container?.scrollWidth / steps.length;
    const position = container?.scrollLeft + widthToJump * scrollDirection?.dir;
    container?.scroll({ left: position, behavior: 'smooth' })
  },[scrollDirection])

  useEffect(() => {
    const activeStepElement = document.querySelector(`.step-type-${steps[activeStep]?.type}`);
    activeStepElement?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });
  }, [activeStep, steps])

  const currentStepHasMissingData = stepHasMissingData(mapedStepTypeInputStatus, activeStep)

  if(currentStepHasMissingData && stepsPassed !== activeStep) {
    stepsPassedSet(activeStep)
  }


  return (
    <StyledStepperWrapper direction={'row'}>
      { stepperOverflown && renderArrowButtonLeft() }
      <HeaderNavigation activeStep={activeStep} ref={elementRef} style={{borderRadius: stepperOverflown ? 0 : '0.5em'}}>
        {
          steps.map((step, i) => {
            const { type, stepTitle } = step;
            const disableStep = i >= activeStep
              && currentStepBlocked
            const prevStepIndex = i-1;
            const prevHasMissingData = prevStepIndex === -1
              ? false
              : stepHasMissingData(mapedStepTypeInputStatus, prevStepIndex);

            const completed = (i <= stepsPassed && !prevHasMissingData) || false

            const key = `${type}_${i}`;

            return (
              <StyledStep
                key={key}
                className={clsx({ completed }, `step-type-${step.type}`)}
                title={stepTitle}
                completed={completed}
                >
                  <StepButton
                    aria-label={ t('ariaLabel.stepIndex',{stepName:stepTitle, index: i + 1, count: steps.length})}
                    onClick = {() => onNavigateClick(i)}
                    disabled={disableStep ||!completed || prevHasMissingData}
                    icon={StepTypeIcon[type] || null}
                    />

              </StyledStep>
            )
          })
        }
      </HeaderNavigation>
      { stepperOverflown && renderArrowButtonRight() }
    </StyledStepperWrapper>
  );
});

export default connect(
    ({ current: { steps: { activeStep, stepsPassed } } }) => ({ activeStep, stepsPassed}),
    { stepsPassedSet })
    (NavigationHeader);